import React from 'react';
import { logDebugging } from '../log/logger';
import loadScript from '../utils/load_script';
import AdsController from './ads.controller';
import AdsModel from './models/ads.model';
import * as AdsControllerEvent from './events/ad.controller.events';
import * as AdsManagerEvent from './events/ads.manager.events';
import * as POSITIONS from './constants/positions';
import PlayerEvent from '../core/events/player.event';
import VideoPlayerContainer from './components/ad.video.container';
import { loadSSPDataModel } from '../ssp/sspTappxManager';
// import { servicemid, servicepos, servicepre } from '../ssp/service.examples';

export default class AdsManager {
  constructor(config, position, rootCreated) {
    this.idComponent = config.targetAdId;
    this.config = config;
    this.stat = 'standby';
    this.eventAdsManager = new PlayerEvent('onAdsManagerEvent');
    this.status = 'standby';
    this.position = position;
    this.numBlock = 0;
    this.rootCreated = rootCreated;
    this.loadVideo();
  }

  async getBlockAd() {
    const sspServiceData = await loadSSPDataModel(this.config, this.position);
    const blockAd = {};
    let ads = [];

    if (sspServiceData?.totalBlocks > 0) {
      const sspAds = sspServiceData.getBlocks();
      [ads] = sspAds;
    }

    let numAdsByBlock = 0;
    switch (this.position) {
      case POSITIONS.PREROLL:
        numAdsByBlock = this.config.numAdsPre;
        break;
      case POSITIONS.MIDROLL:
        numAdsByBlock = this.config.numAdsMid;
        break;
      case POSITIONS.POSROLL:
        numAdsByBlock = this.config.numAdsPos;
        break;
      default:
        numAdsByBlock = 0;
    }

    blockAd.extInfo = sspServiceData?.getExtInfo();
    blockAd.numAdsByBlock = numAdsByBlock || 0;
    blockAd.ads = ads;
    blockAd.position = this.position;
    blockAd.timesMidroll = this.config.timesMidroll;
    return blockAd;
  }

  async initController(autoplay) {
    logDebugging(`[AdsManager] inicializo llamadas publicidad ${this.position}`);
    this.status = 'loading';
    const blockAd = await this.getBlockAd();
    const adsModel = new AdsModel(blockAd);
    if (adsModel.getNumAdsByBlock() === 0) {
      logDebugging(
        `[AdsManager] el numero de ads en el bloque es ${adsModel.getNumAdsByBlock()}. No cargamos publi`,
      );
      return;
    }
    if (adsModel.isImaAd()) {
      // eslint-disable-next-line no-undef
      if (typeof window.google === 'undefined') {
        await loadScript('https://imasdk.googleapis.com/js/sdkloader/ima3.js');
      }
    }
    if (this.adsController) {
      this.revomeEvents();
    }
    this.adsController = new AdsController(this.idComponent, adsModel, this.config, this.position);
    if ((this.position === POSITIONS.POSROLL || this.position === POSITIONS.PREROLL) && !autoplay) {
      this.adsController.callInBackground = true;
    }
    this.activateEvents();

    this.adsController.requestAds().then((ad) => {
      logDebugging('[AdsManager] event from adsController', ad, adsModel);
      if (adsModel.getErrorAds().length === adsModel.getTotalAds()) {
        logDebugging('Todas las campañas llamadas han devuelto error.');
        if (!this.adsController.callInBackground) {
          logDebugging('Probamos display...');
          this.adsController.getNextAd();
        }
        // this.dispatchEvent([AdsManagerEvent.BLOCK_COMPLETED, this.position]);
      }
    });
  }

  activateEvents() {
    this.adsController.getEvent().subscribe((sender, eventArgs) => {
      const [event, ad] = eventArgs.message;
      switch (event) {
        case AdsControllerEvent.FIRST_AD_LOADED:
          // this.status = 'playing';
          logDebugging('[AdsManager] Inicio reproduccion bloque publicidad', ad.cid);
          this.dispatchEvent([AdsManagerEvent.INIT_BLOCK, this.position]);
          break;
        case AdsControllerEvent.BLOCK_COMPLETED:
        case AdsControllerEvent.AD_ERROR:
          logDebugging('[AdsManager] Bloque de publicidad completado', ad);
          this.status = 'completed';
          this.isNotFirstPreroll = true;
          this.numBlock += 1;
          this.dispatchEvent([AdsManagerEvent.BLOCK_COMPLETED, this.position]);
          break;
        case AdsControllerEvent.AD_CHANGED:
          // this.loadVideo();
          break;
        case AdsControllerEvent.AD_PLAY_STARTED:
          this.status = 'playing';
          this.loadVideo();
          setTimeout(() => this.resize(), 300);
          break;
        case AdsControllerEvent.AD_PLAY_COMPLETED:
          this.status = 'end';
          this.loadVideo();
          break;
        case AdsControllerEvent.AD_PAUSED:
          this.status = 'paused';
          this.loadVideo();
          break;
        case AdsControllerEvent.AD_RESUME:
          this.status = 'resumed';
          this.loadVideo();
          break;
        case AdsControllerEvent.AD_SHOW_SKIP:
          // this.loadVideo('loading');
          break;
        case AdsControllerEvent.SEARCH_AD:
          logDebugging(
            '[AdsManager] No hay publicidad suficiente para llenar el bloque. Buscamos...',
            ad,
          );
          this.getBlockAd().then((blockAd) => {
            logDebugging(blockAd);
            this.adsController.addNewAds(blockAd);
          });

          break;
        default:
          break;
      }
      // logDebugging('[AdsController event]', eventArgs);
    });
  }

  revomeEvents() {
    this.adsController?.adControllerSelected?.remove();
    this.adsController.getEvent().unsubscribe();
  }

  playAds() {
    const [nextAd] = this.adsController?.adsModel.getDeliveryAds() || [];
    if (!nextAd) {
      this.initController(true);
    } else {
      this.adsController?.playAds();
    }
  }

  getEvent() {
    return this.eventAdsManager;
  }

  dispatchEvent(arg) {
    this.eventAdsManager.fire(this, { message: arg });
  }

  loadVideo() {
    if (this.isRootUnmount) return;
    this.rootCreated.render(
      <VideoPlayerContainer
        config={this.config}
        adVideo={this.adsController?.adControllerSelected}
        viewState={this.status}
      />,
    );
  }

  resize() {
    this.adsController?.resize();
  }

  set status(stat) {
    if (this.status !== stat) {
      this.stat = stat;
      logDebugging('[AdsManager] CAMBIO ESTADO', stat);
      this.dispatchEvent([AdsManagerEvent.STATUS_CHANGED, this.position]);
    }
  }

  get status() {
    return this.stat;
  }
}
